import { render } from "./ChartHolderCard.vue?vue&type=template&id=b539bf5e&scoped=true"
import script from "./ChartHolderCard.vue?vue&type=script&lang=js"
export * from "./ChartHolderCard.vue?vue&type=script&lang=js"

import "./ChartHolderCard.vue?vue&type=style&index=0&id=b539bf5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b539bf5e"]])

export default __exports__